import { render } from "./OrderFormSummary.vue?vue&type=template&id=16b71890"
import script from "./OrderFormSummary.vue?vue&type=script&lang=js"
export * from "./OrderFormSummary.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__